import { apiClient } from '../../utils/apiClient';

// Get all users with pagination
const getAllUsers = async (options = {}) => {
  const { page = 1, limit = 10, activeOnly = false, search = '' } = options;
  
  // Build query parameters
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString()
  });
  
  if (activeOnly) {
    queryParams.append('activeOnly', 'true');
  }
  
  if (search) {
    queryParams.append('search', search);
  }
  
  const { data } = await apiClient.get(`users/?${queryParams}`);
  
  // Backend returns { users: [...], pagination: {...} }
  const usersArray = data.users || data;
  const pagination = data.pagination || {
    page,
    limit,
    total: Array.isArray(usersArray) ? usersArray.length : 0,
    totalPages: 1,
    hasNext: false,
    hasPrev: false
  };
  
  if (Array.isArray(usersArray)) {
    if (usersArray.length > 0) {
      // Parse user roles from userRoles[].role.name structure
      if (usersArray[0]?.userRoles) {
        const roles = usersArray[0].userRoles.map(ur => ur.role?.name).filter(Boolean);
      }
    }
    
    // Transform users to extract roles correctly and normalize field names
    const transformedUsers = usersArray.map(user => ({
      ...user,
      // Normalize field names from backend snake_case to frontend camelCase
      lastLogin: user.last_login || user.lastLogin,
      isActive: user.is_active !== undefined ? user.is_active : user.isActive,
      createdAt: user.created_at || user.createdAt,
      updatedAt: user.updated_at || user.updatedAt,
      // Extract role names from userRoles[].role.name structure
      roles: user.userRoles ? user.userRoles.map(ur => ur.role?.name).filter(Boolean) : []
    }));
    
    return {
      users: transformedUsers,
      pagination
    };
  } else {
    console.warn('Expected users array but got:', typeof usersArray);
    return {
      users: [],
      pagination
    };
  }
  
  return usersArray || [];
};

// Get user by ID
const getUserById = async (userId) => {
  // Console log removed for production
  const { data } = await apiClient.get(`users/${userId}`);
  // Console log removed for production
  // Console log removed for production
  // Console log removed for production
  // Console log removed for production
  
  if (data && data.userRoles) {
    // Extract role names from userRoles[].role.name structure
    const roles = data.userRoles.map(ur => ur.role?.name).filter(Boolean);
  // Console log removed for production
    
    return {
      ...data,
      roles: roles
    };
  }
  
  return data;
};

// Create new user
const createUser = async (userData) => {
  console.log('📤 [UserService] Creating user with data:', {
    username: userData.username,
    email: userData.email,
    roles: userData.roles,
    is_active: userData.is_active
  });
  
  try {
    const { data } = await apiClient.post('users/', userData);
    console.log('✅ [UserService] User created successfully:', {
      userId: data.id,
      username: data.username,
      email: data.email,
      roles: data.userRoles?.map(ur => ur.role?.name)
    });
    return data;
  } catch (error) {
    console.error('❌ [UserService] Failed to create user:', {
      error: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};

// Update user
const updateUser = async (userId, userData) => {
  const { data } = await apiClient.put(`users/${userId}`, userData);
  return data;
};

// Delete user
const deleteUser = async (userId) => {
  const { data } = await apiClient.delete(`users/${userId}`);
  return data;
};

const userService = {
  getAllUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser
};

export default userService;
